// Bezpečné XML utility (§38). Parsování přes DOMParser (nefetchuje externí entity)
// + explicitní odmítnutí DOCTYPE/ENTITY, aby se zabránilo XXE a entity-expansion.
export function parseXML(str) {
  if (typeof str !== "string") str = new TextDecoder().decode(str);
  // Odmítnout deklarace entit / externí DTD.
  if (/<!DOCTYPE/i.test(str) && /<!ENTITY|SYSTEM|PUBLIC/i.test(str)) throw new Error("XML s externími entitami/DTD není povoleno.");
  const doc = new DOMParser().parseFromString(str, "application/xml");
  const err = doc.getElementsByTagName("parsererror");
  if (err && err.length) throw new Error("Neplatné XML: " + (err[0].textContent || "").slice(0, 120));
  return doc;
}

export function child(el, tag) { if (!el) return null; for (const c of el.children) if (c.tagName === tag) return c; return null; }
export function children(el, tag) { const out = []; if (!el) return out; for (const c of el.children) if (c.tagName === tag) out.push(c); return out; }
export function text(el, tag) { const c = tag ? child(el, tag) : el; return c ? (c.textContent || "").trim() || null : null; }
export function attr(el, name) { return el && el.getAttribute ? el.getAttribute(name) : null; }
export function num(v) { const n = parseFloat(v); return Number.isFinite(n) ? n : null; }

export function vec3(el) {
  if (!el) return null;
  return { x: num(text(el, "X")), y: num(text(el, "Y")), z: num(text(el, "Z")) };
}

// --- Zápis ------------------------------------------------------------------
export function esc(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" }[c]));
}
export function tag(name, content, attrs) {
  const a = attrs ? Object.entries(attrs).filter(([, v]) => v != null).map(([k, v]) => ` ${k}="${esc(v)}"`).join("") : "";
  if (content == null || content === "") return `<${name}${a}/>`;
  return `<${name}${a}>${content}</${name}>`;
}
export function el(name, value, attrs) { return tag(name, esc(value), attrs); }
export function vec3XML(name, v) {
  if (!v) return "";
  return tag(name, el("X", v.x) + el("Y", v.y) + el("Z", v.z));
}
